// GenderDonut.tsx
import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { formatNumber } from "../../../../services/mixin";
import { useNavigate } from "react-router-dom";
import { IDataDefaulFilter } from "..";
import '../styles.scss'

interface props {
    data?: {
        totalCustomer: number;
        totalMale: number;
        totalFemale: number;
        totalElse: number;
    }
    dataFilter: IDataDefaulFilter | undefined

}

const GENDER_ITEMS = [
    { key: "totalMale", name: "Nam", color: "#1890FF", gender: 0 },
    { key: "totalFemale", name: "Nữ", color: "#7B61FF", gender: 1 },
    { key: "totalElse", name: "Không xác định", color: "#F59C23", gender: 2 },
] as const;

export const GenderDonut: React.FC<props> = ({ data, dataFilter }) => {
    const navigate = useNavigate()

    const total = data?.totalCustomer ?? 0;

    const chartData = GENDER_ITEMS.map((item) => ({
        gender: item.gender,
        name: item.name,
        value: data?.[item.key] ?? 0,
        color: item.color,
    }));

    return (
        <div className="custom-page-css w-full flex flex-1 flex-col justify-between  items-center gap-6">
            <div className="custom-page-css relative w-240px h-240px">

                <ResponsiveContainer>
                    <PieChart>
                        <Pie
                            data={chartData}
                            dataKey="value"
                            innerRadius={80}
                            outerRadius={110}
                            paddingAngle={0}
                            cursor="pointer"
                            onClick={(entry) => navigate(
                                `/analysis-report/member-card-list`,
                                {
                                    state: {
                                        type: 2,
                                        listUnit: dataFilter?.unitIds,
                                        listRank: dataFilter?.rankIds,
                                        fromMonth: dataFilter?.fromMonth,
                                        toMonth: dataFilter?.toMonth,
                                        gender: entry.gender,
                                        title: entry.gender === 0 ? 'Khách hàng có giới tính là Nam' : entry.gender === 1 ? 'Khách hàng có giới tính là Nữ' : 'Khách hàng có giới tính không xác định'
                                    }
                                }
                            )}
                        >
                            {chartData.map((entry, index) => (
                                <Cell key={index} fill={entry.color} />
                            ))}
                        </Pie>
                    </PieChart>
                </ResponsiveContainer>

                {/* Center text */}
                <div className="custom-page-css absolute inset-0 flex flex-col items-center justify-center pointer-events-none"
                    style={{ inset: 0 }}>
                    <div className="custom-page-css text-2xl font-regular text-344054">
                        {formatNumber(total)}
                    </div>
                    <div className="custom-page-css  text-sm text-98A2B3 font-regular">Khách hàng</div>
                </div>
            </div>

            {/* Legend */}
            <div className="space-y-2 pb-2">
                {chartData.map((item) => {
                    const percent = total
                        ? ((item.value / total) * 100).toFixed(0)
                        : 0;
                    return (
                        <div key={item.name} className="custom-page-css flex items-center gap-2 text-sm">
                            <span
                                className="custom-page-css w-2 h-2 rounded-full"
                                style={{ background: item.color }}
                            />
                            <span>
                                {item.name}: {formatNumber(item.value)} ({percent}%)
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
